module.exports = __webpack_public_path__ + "static/media/morning-star2.6e44757f.jpg";